import { useState } from 'react';
import { ModuleData } from '../../Types/containerV2';
import { isWelcomeGuideButtonModuleContent } from '../../Types/containerV2/modules/welcomeGuideButton';
import ModuleActionSurface from './ModuleActionSurface';
import { setUserSetting, IsLoggedIn } from '../../Services/user';
import { getPathWithRootPath, setLocalStorage } from '../../Services/common';
import { useGlobalState } from '../../Contexts/globalStateContext';
import { useOptionalEventContext } from '../../Contexts/eventContext';
import './WelcomeGuideButtonModule.scss';

type WelcomeGuideButtonModuleProps = {
	module: ModuleData;
};

const WELCOME_GUIDE_SETTING_KEY = 'HasShownWelcomeGuide';
const WELCOME_GUIDE_COMPLETED_EVENT = 'WELCOMEGUIDE.COMPLETED';

const WelcomeGuideButtonModule = ({ module }: WelcomeGuideButtonModuleProps) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const {
		state: { user },
	} = useGlobalState();
	const eventContext = useOptionalEventContext();

	if (!isWelcomeGuideButtonModuleContent(module.content)) {
		return null;
	}

	const content = module.content;

	const finishWelcomeGuide = async () => {
		if (isSubmitting) {
			return;
		}

		setIsSubmitting(true);
		setLocalStorage(WELCOME_GUIDE_SETTING_KEY, 'true');

		try {
			if (user && IsLoggedIn(user)) {
				await setUserSetting(WELCOME_GUIDE_SETTING_KEY, 'true');
			}

			const targetUrl = getResolvedTargetUrl(content.buttonLink);
			if (targetUrl) {
				window.location.href = targetUrl;
				return;
			}

			eventContext?.dispatch(WELCOME_GUIDE_COMPLETED_EVENT);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<button
			type='button'
			className='biz-welcome-guide-button-module__button'
			onClick={finishWelcomeGuide}
			disabled={isSubmitting}
		>
			<ModuleActionSurface
				className='biz-welcome-guide-button-module'
				label={content.buttonText || 'Lets get started!'}
				disabled={isSubmitting}
			/>
		</button>
	);
};

function getResolvedTargetUrl(buttonLink: string) {
	const trimmedLink = buttonLink.trim();
	if (!trimmedLink) {
		return '';
	}

	if (/^https?:/i.test(trimmedLink)) {
		return trimmedLink;
	}

	return getPathWithRootPath(trimmedLink);
}

export default WelcomeGuideButtonModule;
